import React from "react";
import classes from "./MatchEvents2.module.css";
import { useTranslation } from "react-i18next";

const MatchEvents2 = ({ team_name, data }) => {
    const {t}=useTranslation();

    return (
        <div className={classes.panel}>

            {/* Header */}
            <div className={classes.header}>
                <span className={classes.headerIcon}>⚽</span>
                <p className={classes.headerTitle}>{team_name}</p>
            </div>

            {/* Events list */}
            <div className={classes.list}>
                {data?.length > 0 ? (
                    data.map((item, i) => (
                        <div className={classes.eventRow} key={i}>
                            {/* Minute badge */}
                            <div className={classes.minuteBadge}>
                                <span className={classes.minuteNum}>{item?.time?.elapsed}</span>
                                <span className={classes.minuteTick}>'</span>
                            </div>

                            {/* Vertical connector */}
                            {i < data.length - 1 && <div className={classes.connector} />}

                            {/* Player info */}
                            <div className={classes.playerInfo}>
                                <span className={classes.playerName}>{item?.player?.name}</span>
                                {item?.assist?.name && (
                                    <span className={classes.assistName}>
                                        {t("124")} {item.assist.name}
                                    </span>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className={classes.empty}>
                        <span className={classes.emptyIcon}>—</span>
                        <p className={classes.emptyText}>{t("125")}</p>
                    </div>
                )}
            </div>

        </div>
    );
};

export default MatchEvents2;